export function uniqueBy(array, by) {
  return unique(array.map(o => o[by])).map(value => array.find(item => item[by] === value))
}

export function unique(array) {
  return [...new Set(array)]
}
